import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CampaignStatus } from '../../../../core/enum/campaign-status.enum';
import { InvestmentStatus } from '../../../../core/enum/investment-status.enum';
import { RefundStatus } from '../../../../core/enum/refund-status.enum';
import { MyInvestment } from '../../../../core/models/investment/my-investment';
import { PopupService } from '../../../../shared/services/popup/popup.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MyInvestmentsRefundComponent } from 'src/app/pages/my-profile/my-investments/my-investments-refund/my-investments-refund.component';
import { PaymentMethod } from '../../../../core/models/payment/payment-method';
import { Campaign } from '../../../../core/models/campaign/campaign';
import { InvestmentCancellationService } from '../../../../shared/services/investment-cancellation/investment-cancellation.service';

@Component({
    selector: 'app-investments',
    templateUrl: './investments.component.html',
    styleUrls: ['./investments.component.scss'],
    standalone: false
})
export class InvestmentsComponent implements OnChanges {
  @Input() campaignStatus: CampaignStatus;
  @Input() myInvestment: MyInvestment;
  @Input() campaign: Campaign;
  @Output() getMyInvestment = new EventEmitter();
  displayColumns: string[] = [
    'PledgedAmount',
    'RefundedAmount',
    'InvestmentStatus',
    'RefundStatus',
    'RequestForMoreInfo',
    'CreatedAt',
    'Action',
  ];

  InvestmentStatus: typeof InvestmentStatus = InvestmentStatus;
  RefundStatus: typeof RefundStatus = RefundStatus;
  CampaignStatus: typeof CampaignStatus = CampaignStatus;
  paymentMethod: PaymentMethod;
  investorEmail: string = '';
  params = {
    currentPage: 1,
    take: 10,
  };
  constructor(
    private popupService: PopupService,
    private readonly modalService: NgbModal,
    private investmentCancellationService: InvestmentCancellationService,
  ) {}

  ngOnChanges() {
    if (
      [CampaignStatus.ShareAllotment, CampaignStatus.Success, CampaignStatus.Fail].includes(
        this.campaignStatus,
      )
    )
      this.displayColumns = this.displayColumns.filter((col) => col != 'Action');

    if (this.campaignStatus == CampaignStatus.ShareAllotment)
      this.displayColumns = this.displayColumns.filter(
        (col) => !['RefundedAmount', 'InvestmentStatus', 'RefundStatus'].includes(col),
      );

    if (this.myInvestment?.investments?.length > 0) {
      this.myInvestment.investments.sort((val1, val2) => {
        return <any>new Date(val2.createdAt) - <any>new Date(val1.createdAt);
      });
    }
  }

  cancelInvestment(investmentId: number) {
    this.withdrawValidation(() => {
      this.popupService.confirm('investment.confirmCancelInvestment').then(
        () => {
          this.investmentCancellationService.initiateCancellation(
            'refund',
            investmentId,
            this.investorEmail,
            this.campaign.name,
            this.campaign.slug,
            () => {
              this.getMyInvestment.emit();
            },
          );
        },
        () => {},
      );
    });
  }
  withdrawValidation(afterValidation?: () => void): void {
    const popupOptions = {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    } as NgbModalOptions;

    const modalRef = this.modalService.open(MyInvestmentsRefundComponent, popupOptions);
    modalRef.result.then(
      (savedData) => {
        this.paymentMethod = savedData;
        if (afterValidation) afterValidation();
      },
      () => {},
    );
  }
}
